import { gql, isMeditationCardItem, isClassCardItem, CardItem, PracticeCardItem } from '@yi/core';

export interface Teacher {
  author_id: number;
  article_count: number;
  course_count: number;
  first: string;
  last: string;
  featured_order: number;
  thumb: { url: string };
  category: string[];
  logged_in_member_id: string;
  bio_snippet: string;
  main_style: string;
}

export interface TeacherWithFavoriteData extends Teacher {
  favorite: boolean;
  favorite_order: number;
  favorited_on: number;
}

interface Category {
  name: string;
}
interface Image {
  url: string;
  alt_text: string | null;
}

export interface Class {
  id: string;
  title: string;
  subtitle?: string;
  url_title: string;
  status: 'OPEN' | 'CLOSED';
  entry_date: string;
  landing_page_image: Image;
  no_text_image: Image;
  square_image: Image;
  short_summary: string;
  seo_title: string;
  language: 'ENGLISH' | 'SPANISH';
  teacher: { full_name: string };
  entry_type?: 'ARTICLE' | 'SLIDESHOW' | 'VIDEO' | 'AUDIO' | 'POSE' | 'LIVE';
  jwplayer_id: string;
  media_duration: number;
  tags?: { text: string }[];
  secondary_author: { full_name: string } | null;
  style: Category[];
  intensity: Category[];
  level: Category[];
  anatomy?: Category[];
  props?: Category[];
  focus?: Category[];
  secondary_style?: Category[];
  energetic_effect?: Category[];
  time_of_day?: Category[];
  movement?: Category[];
  wellbeing: Category[];
  poses: Category[];
}

export interface ClassWithFavoriteData extends Class {
  favorite: boolean;
  favorite_order: number;
  favorited_on: number;
}

export interface Article {
  anatomical_focus: string[];
  authorId: number;
  snippet: string;
  duration: string[];
  entry_id: number;
  intensity: string[];
  level: string[];
  style: string[];
  teacher: string[];
  thumb: string;
  title: string;
  topic: string[];
  type: string;
  url: string;
}

export type Course = Omit<gql.typesSsr.Query_Course_CoursePlayerPage_yi_Course, '__typename'>;
export type Chapter = gql.typesSsr.Query_Course_CoursePlayerPage_yi_Course_units_chapters;
export type Module = gql.typesSsr.Query_Course_CoursePlayerPage_yi_Course_units_chapters_modules;
export type SalesCourse = gql.typesSsr.Query_Course_yi_Course;
export type SalesCourseBundle = gql.typesSsr.Query_CourseBundle_yi_CourseBundle;
export type SalesChapter = gql.typesSsr.Query_Course_yi_Course_chapters;
export type SalesModule = gql.typesSsr.Query_Course_yi_Course_chapters_modules;

export const isUserCreatedPracticeCardItem = (
  item: CardItem & { __typename?: string },
): item is gql.typesClient.Query_CurrentUser_CurrentUser_recent_user_created_activity =>
  item && '__typename' in item && item.__typename === 'UserCreatedActivity';

export const isMeditationPracticeCardItem = (
  item: CardItem & { __typename?: string },
): item is gql.typesClient.Query_CurrentUser_CurrentUser_recent_meditation_activity =>
  item && '__typename' in item && item.__typename === 'MeditationActivity';

export const isClassPracticeCardItem = (
  item: CardItem & { __typename?: string },
): item is gql.typesClient.Query_CurrentUser_CurrentUser_recent_class_activity =>
  item && '__typename' in item && item.__typename === 'ClassActivity';

export const isPracticeCardItem = (
  item: CardItem & { __typename?: string },
): item is PracticeCardItem =>
  isUserCreatedPracticeCardItem(item) || isMeditationCardItem(item) || isClassCardItem(item);
